import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconCustomerPages = (props: IconProps) => (
  <svg
    className={cn(iconStyles(props))}
    width="23"
    height="23"
    viewBox="0 0 23 23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.009,13.392v1.587 c0,0,2.219,0.667,4.705,1.333c2.488,0.666,2.641,2.901,2.641,
      2.901v3.176H1.646v-3.176c0,0,0.153-2.235,2.64-2.901 s4.706-1.333,4.706-1.333v-1.587"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.304,10.066
      c0.665-0.027,0.951-0.756,1.048-1.497c0.097-0.741,0.152-1.47-0.71-1.77l0,
      0c-0.033-3.801-1.276-6.189-5.087-6.189 c-3.506,0-5.048,2.359-5.092,6.158l0,
      0c-0.589,0.018-0.864,0.96-0.742,1.918c0.114,0.902,0.536,1.568,1.092,1.43l0,0
      c0.741,2.429,2.586,3.864,4.741,3.864C13.72,13.98,15.568,12.512,16.304,10.066L16.304,10.066z"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
